import { Link } from 'react-router-dom';
import { movies, articles } from '@/mocks/data';
import MovieCard from '@/components/base/MovieCard';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestUpdates() {
  const newMovies = movies.filter((m) => m.isNew).slice(0, 4);
  const latestArticles = articles.slice(0, 2);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">刚刚更新的热门影片</p>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5 mb-14">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>

        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新影视动态与深度影评</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}